import * as React from 'react';

// hooks
import useMedia from '~/hooks/use-media';
// interfaces
import { Devices, MinScreenSizes } from '~/types/device';
export { Devices, MinScreenSizes };

interface IProps {
	allowedDevices?: Devices[];
	renderOnMismatch?: boolean;
}

const MediaQuery: React.FC<React.PropsWithChildren<IProps>> = ({
	allowedDevices = [],
	children,
	renderOnMismatch = false,
}) => {
	const { device } = useMedia();

	// Resize on mount
	React.useEffect(() => {
		const resize = new Event('resize');
		window.dispatchEvent(resize);
	}, []);

	// Short circuit
	if (
		!device ||
		(!renderOnMismatch &&
			Array.isArray(allowedDevices) &&
			allowedDevices.indexOf(device) === -1)
	) {
		return null;
	}

	// Handle single child
	if (typeof children === 'function') {
		return children(device);
	}

	// Handle multiple children
	const childrenComponent = React.Children.map(children, child => {
		const item = child as React.ReactElement;

		return React.cloneElement(item, {
			device,
		});
	});

	return childrenComponent;
};

export default MediaQuery;
